import type { WorkbenchCard } from '@mybusinessmate/schema';
import { LANES } from '../../lib/workbench-display';
import { TaskCard } from './task-card';

/**
 * Figma A05.7: five lanes side by side, each as tall as its cards. No dragging: a card moves lane by itself as the work
 * does (the slider, a version sent, a lead's answer), so the board is always what is true.
 */
export function Board({
  cards,
  viewerId,
  selectedId,
  onOpen,
}: {
  cards: WorkbenchCard[];
  viewerId: string | undefined;
  selectedId: string | null;
  onOpen: (card: WorkbenchCard) => void;
}) {
  return (
    <div className="overflow-x-auto">
      <div className="grid grid-cols-[repeat(5,minmax(var(--mbm-layout-board-lane-min-width),1fr))] items-start gap-(--mbm-space-3-5)">
        {LANES.map((lane) => {
          const inLane = cards.filter((card) => card.column === lane.id);
          return (
            <section
              key={lane.id}
              aria-label={lane.title}
              className="flex flex-col gap-(--mbm-space-2-5) rounded-(--mbm-component-radius-board-column) bg-board-column px-(--mbm-space-2-5) py-(--mbm-space-3)"
            >
              <header className="flex flex-col gap-(--mbm-space-0-5) px-(--mbm-space-1-5) pb-(--mbm-space-1)">
                <h2 className="flex items-center gap-(--mbm-space-2) text-label-large text-text-primary">
                  {lane.title}
                  <span className="text-label-medium text-text-tertiary">{inLane.length}</span>
                </h2>
                <p className="text-body-xsmall text-text-tertiary">{lane.hint}</p>
              </header>
              {inLane.map((card) => (
                <TaskCard
                  key={card.taskId}
                  card={card}
                  viewerId={viewerId}
                  selected={selectedId === card.taskId}
                  onOpen={() => onOpen(card)}
                />
              ))}
            </section>
          );
        })}
      </div>
    </div>
  );
}
